import httpService from "./http.service";

export function getTranscripts (query) {
  return httpService.get(`recordings-api/recordings${query}`, undefined, {});
}

export function getTranscriptById (id) {
  return httpService.get(`recordings-api/recordings/${id}`);
}

export function deleteTranscriptById (id) {
  return httpService.remove(`recordings-api/recordings/${id}`);
}

export function updateTranscripts (id, transcripts) {
  return httpService.put(`recordings-api/recordings/${id}/transcript`, {transcripts});
}

export function updateTranscript (id, transcript) {
  return httpService.put(`recordings-api/recordings/${id}`, transcript);
}

export function getTrashItems (params) {
  return httpService.get('recordings-api/trash', undefined, { params: params });
}

export function emptyTrash () {
  return httpService.remove('recordings-api/trash');
}

export function restoreTranscript (id) {
  return httpService.put(`recordings-api/trash/${id}/restoration`);
}

export function deleteTranscriptForever (id) {
  return httpService.remove(`recordings-api/${id}`);
}

export function getTranscriptVersions (id) {
  return httpService.get(`recordings-api/recordings/${id}/transcript/versions`);
}

export function getTranscriptDetailByVersion (id, version) {
  return httpService.get(`recordings-api/recordings/${id}/transcript/versions/${version}`);
}

export function getSpeakerNames () {
  return httpService.get('recordings-api/recordings/speakers');
}

export function querySearch (searchKeyword) {
  return httpService.post('recordings-api/recordings/search', { query: searchKeyword });
}

export function getStatistics(id) {
  return httpService.get(`recordings-api/recordings/${id}/statistics`);
}

export function getAudioWaveform(id) {
  return httpService.get(`recordings-api/recordings/${id}/waveform`);
}

